import { ChangeDetectionStrategy, Component, Inject, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CallState } from '@lcs/shared/api';
import { PromptTypes } from 'generated/graphql-types';
import { Observable } from 'rxjs';
import { LcsDialogService } from 'src/app/common-components/dialog/dialog.service';
import { FormComponent } from 'src/app/common-components/forms-base/form-component.interface';
import { ExtensionDetailFormService } from '../../extension-details/services/extension-detail-form.service';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    providers: [ExtensionDetailFormService],
    selector: 'ndt-add-existing-prompt',
    templateUrl: './add-existing-prompt.component.html',
    standalone: false
})
export class AddExistingPromptComponent implements FormComponent {
   callState: Observable<CallState>;

   form: UntypedFormGroup;

   accountId: number | null;

   promptTypesToInclude: PromptTypes[] | null;

   constructor(
      private fb: UntypedFormBuilder,
      private dialogService: LcsDialogService,
      public dialogRef: MatDialogRef<AddExistingPromptComponent>,
      @Inject(MAT_DIALOG_DATA)
      public data: { accountId: number | null | undefined; promptTypesToInclude: PromptTypes[] | null }
   ) {
      this.form = this.fb.group({
         prompt: this.fb.control(null),
      });
      if (this.data !== null && this.data.promptTypesToInclude !== null) {
         this.promptTypesToInclude = data.promptTypesToInclude;
      } else {
         this.promptTypesToInclude = null;
      }
      this.accountId = data.accountId ?? null;
   }

   onClose(): void {
      this.dialogService.close();
   }

   onCreate(): void {
      if (this.form.valid) {
         this.dialogRef.close(this.form.value.prompt);
      }
   }
}
